import GrocerySubCategoriesTable from 'components/GrocerySubCategories';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const GrocerySubCategories = () => {
  const permissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );
  const canViewCategories = checkPermission(permissions, {
    permissionName: 'GroceryCategories',
    permission: ['view', 'viewAll'],
  });
  const canViewSubCategories = checkPermission(permissions, {
    permissionName: 'GrocerySubCategories',
    permission: ['view', 'viewAll'],
  });
  const canView = canViewCategories && canViewSubCategories;

  return <div>{canView && <GrocerySubCategoriesTable />}</div>;
};
